import React, { useState, type CSSProperties } from "react";
import { Select } from "antd";
import type { LocationOption } from "../utils/hooks/useLocationOptions";
const LocationSelect: React.FC<{
  value?: string;
  onChange?: (value?: string) => void;
  options: LocationOption[];
  placeholder: string;
  onPicked?: (value?: string) => void;
  /* Opt-in override for antd's default substring matcher; leaving it out keeps
     the stock behaviour for callers that have not asked for anything else. */
  filterOption?: (input: string, option?: LocationOption) => boolean;
  style?: CSSProperties;
}> = React.memo(({
  value,
  onChange,
  options,
  placeholder,
  onPicked,
  style = { width: "100%", height: "100%" },
  ...rest
}) => {
  const [search, setSearch] = useState("");

  return (
    <Select
      {...rest}
      showSearch
      allowClear
      value={value}
      placeholder={placeholder}
      style={style}
      options={options}
      optionFilterProp="label"
      popupMatchSelectWidth={420}
      open={search.length > 0}
      onSearch={setSearch}
      onBlur={() => setSearch("")}
      onClear={() => setSearch("")}
      onChange={(next) => {
        setSearch("");
        onChange?.(next);
        onPicked?.(next);
      }}
    />
  );
});

export default LocationSelect;
